/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from 'owa-viewstate-store';
import { createStore } from 'owa-satcheljs';

import type { UPSCollaborator } from 'places-ups-location-operations';

const getStore = createStore('places-ups-location-store', {
    // Map of buildingId to list of collaborators in that building
    collaboratorsInOfficeStatus: null as UPSCollaborator[] | null,
    // Map of buildingId to list of collaborators that are in the users meetings and are in that building
    collaboratorsInMeetingsStatus: null as UPSCollaborator[] | null,
    collaboratorsOutOfficeStatus: null as string[] | null,
    lastServicePeopleInOfficeSuccessfullyCompleted: false,
    lastServicePeopleInMeetingsSuccessfullyCompleted: false,
});

export interface PlacesUpsLocationStore {
    // Map of buildingId to list of collaborators in that building
    collaboratorsInOfficeStatus: UPSCollaborator[] | null;
    // Map of buildingId to list of collaborators that are in the users meetings and are in that building
    collaboratorsInMeetingsStatus: UPSCollaborator[] | null;
    collaboratorsOutOfficeStatus: string[] | null;
    lastServicePeopleInOfficeSuccessfullyCompleted: boolean;
    lastServicePeopleInMeetingsSuccessfullyCompleted: boolean;
}

export const store: PlacesUpsLocationStore =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getStore called at module scope is not allowed. This may cause unwanted side effects. */
    getStore();

const dest = createAccessors('places-ups-location-store', getStore);
const getCollaboratorsInOfficeStatus: () => UPSCollaborator[] | null =
    dest.getCollaboratorsInOfficeStatus;
const setCollaboratorsInOfficeStatus: (newValue: UPSCollaborator[] | null) => void =
    dest.setCollaboratorsInOfficeStatus;
const getCollaboratorsInMeetingsStatus: () => UPSCollaborator[] | null =
    dest.getCollaboratorsInMeetingsStatus;
const setCollaboratorsInMeetingsStatus: (newValue: UPSCollaborator[] | null) => void =
    dest.setCollaboratorsInMeetingsStatus;
const getCollaboratorsOutOfficeStatus: () => string[] | null = dest.getCollaboratorsOutOfficeStatus;
const setCollaboratorsOutOfficeStatus: (newValue: string[] | null) => void =
    dest.setCollaboratorsOutOfficeStatus;
const getLastServicePeopleInOfficeSuccessfullyCompleted: () => boolean =
    dest.getLastServicePeopleInOfficeSuccessfullyCompleted;
const setLastServicePeopleInOfficeSuccessfullyCompleted: (newValue: boolean) => void =
    dest.setLastServicePeopleInOfficeSuccessfullyCompleted;
const getLastServicePeopleInMeetingsSuccessfullyCompleted: () => boolean =
    dest.getLastServicePeopleInMeetingsSuccessfullyCompleted;
const setLastServicePeopleInMeetingsSuccessfullyCompleted: (newValue: boolean) => void =
    dest.setLastServicePeopleInMeetingsSuccessfullyCompleted;

export {
    getCollaboratorsInOfficeStatus,
    setCollaboratorsInOfficeStatus,
    getCollaboratorsInMeetingsStatus,
    setCollaboratorsInMeetingsStatus,
    getCollaboratorsOutOfficeStatus,
    setCollaboratorsOutOfficeStatus,
    getLastServicePeopleInOfficeSuccessfullyCompleted,
    setLastServicePeopleInOfficeSuccessfullyCompleted,
    getLastServicePeopleInMeetingsSuccessfullyCompleted,
    setLastServicePeopleInMeetingsSuccessfullyCompleted,
};
